export enum UserStatus {
  ACTIVE = '__active',
  LIMITED = '__limited',
  CLOSED = '__closed',
  BANNED = '__banned',
  SUSPENDED = '__suspended',
  STATUS_WITHOUT_BETS = '__without_bets',
  STATUS_WITHDRAW_ONLY = '__withdraw_only',
}
